import { render, staticRenderFns } from "./quiz.vue?vue&type=template&id=2f18f52e"
import script from "./quiz.vue?vue&type=script&lang=ts"
export * from "./quiz.vue?vue&type=script&lang=ts"
import style0 from "./quiz.vue?vue&type=style&index=0&id=2f18f52e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports